import { gql } from 'graphql-request'

export const UNAPPROVE_CAMPAIGN = gql`
  mutation UnapproveCampaign($id: Int!) {
    unapproveCampaign(id: $id) {
      message
    }
  }
`
